import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class StorageUtils { 
    
  private KEY_SESSION_STORAGE_VERIFIER = "verifier";
  private KEY_SESSION_STORAGE_CHALLENGE = "challenge";

  public getStVerifierChallenge() {
    const verifier = localStorage.getItem(this.KEY_SESSION_STORAGE_VERIFIER);
    const codeChallenge = localStorage.getItem(this.KEY_SESSION_STORAGE_CHALLENGE);

    return new StVerifierChallenge(verifier, codeChallenge);
  }

  public setStVerifierChallenge(verifier: string, challenge: string) {
    localStorage.setItem(this.KEY_SESSION_STORAGE_VERIFIER, verifier);
    localStorage.setItem(this.KEY_SESSION_STORAGE_CHALLENGE, challenge);
  }

  public removeStVerifierChallenge() {
    localStorage.removeItem(this.KEY_SESSION_STORAGE_VERIFIER);
    localStorage.removeItem(this.KEY_SESSION_STORAGE_CHALLENGE);
  }

}

export class StVerifierChallenge {
    verifier: string | null;
    codeChallenge: string | null;

    constructor(verifier: string | null, codeChallenge: string | null) {
        this.codeChallenge = codeChallenge;
        this.verifier = verifier;
    }
}